import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useAutocomplete } from "@refinedev/mui";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { BaseKey } from "@refinedev/core";
import type { ListProps } from "@refinedev/mui";
import { config } from "config";
import React, { useState } from "react";
import { dataProvider } from "rest-data-provider";

/**
 * `<List>` provides us a layout for displaying the page.
 * It does not contain any logic but adds extra functionalities like a refresh button.
 *
 * @see {@link https://refine.dev/docs/ui-frameworks/mui/components/basic-views/list} for more details.
 */
interface ICategory {
  id: number;
  name: string;
}
type ExtendedUser = ListProps & {
  userId: BaseKey | undefined;
  dataUpdate: (e: any) => void;
};
export const UserBadgeRelationsList: React.FC<ExtendedUser> = ({
  children,
  wrapperProps,
  contentProps,
  userId,
  dataUpdate,
}) => {
  const apiUrl = config().server.api;
  const [open, setOpen] = useState(false);
  const [issueDate, setIssueDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [badgeId, setBadgeId] = useState(0);
  const { autocompleteProps } = useAutocomplete<ICategory>({
    resource: "badge",
    pagination: {
      pageSize: config().relationPageSize,
    },
    filters: [
      {
        field: "status",
        operator: "eq",
        value: 0,
      },
    ],
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSave = () => {
    dataProvider(apiUrl)
      .create({
        resource: "user-badge-relation",
        variables: {
          badgeId,
          expirationDate,
          issueDate,
          userId,
        },
      })
      .then(() => {
        dataUpdate(true);
      });
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const issueDateChangeHandler = (e: any) => {
    setIssueDate(e.format("YYYY-MM-DD"));
  };
  const expirationDateChangeHandler = (e: any) => {
    setExpirationDate(e.format("YYYY-MM-DD"));
  };
  const filterOptions = createFilterOptions({
    stringify: (option: any) => option.name,
  });
  return (
    <Card {...(wrapperProps ?? {})}>
      <CardHeader
        sx={{ display: "flex", flexWrap: "wrap" }}
        color="blue"
        title="Badges"
        action={
          <Box display="flex" gap="16px">
            <Button variant="outlined" onClick={handleClickOpen}>
              ADD
            </Button>
          </Box>
        }
      />
      <CardContent {...(contentProps ?? {})}>{children}</CardContent>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Badges</DialogTitle>
        <DialogContent>
          <Autocomplete
            {...autocompleteProps}
            onInputChange={(event, value) => {}}
            getOptionLabel={(item) => item.name}
            onChange={(event: any, value) => {
              setBadgeId(value.id);
            }}
            placeholder="Select a badge"
            filterOptions={filterOptions}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Badge Type"
                  margin="normal"
                  variant="outlined"
                  required
                />
              );
            }}
          />
          <DatePicker label="Issue Date" onChange={issueDateChangeHandler} />
          <DatePicker
            label="Expiration Date"
            onChange={expirationDateChangeHandler}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
